import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Landing from "@/pages/Landing";
import GridPage from "@/pages/GridPage";
import Dashboard from "@/pages/Dashboard";
import MosaicPage from "@/pages/MosaicPage";
import CertificatePage from "@/pages/CertificatePage";
import PressPage from "@/pages/PressPage";
import PrivacyPage from "@/pages/PrivacyPage";
import MissionPage from "@/pages/MissionPage";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return null;
  if (user === false) return <Navigate to="/" state={{ from: location }} replace />;
  return children;
}

function AppShell() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/grid" element={<GridPage />} />
        <Route path="/mosaico" element={<MosaicPage />} />
        <Route path="/certificato/:index" element={<CertificatePage />} />
        <Route path="/stampa" element={<PressPage />} />
        <Route path="/missione" element={<MissionPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route
          path="/dashboard"
          element={
            <Protected>
              <Dashboard />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
